import React from "react";
import CustomGalleryModal from "../custom/CustomGalleryModal";
import CustomHeading from "../custom/CustomHeading";
import CustomContent from "../custom/CustomContent";

const CustomParagraphComponent = ({ heading, subHeading, content, images }) => {
  const comma = heading.includes(`'`) ? `'` : `’`
  return (
    <div className="flex flex-col gap-3">
      {heading.includes(comma) ? (
        <CustomHeading
          text={heading.slice(0, heading.indexOf(comma))}
          spanText={heading.slice(heading.indexOf(comma), heading.indexOf(comma)+1)}
          secondFontStyle="font-Lato font-bold"
          thirdText={heading.slice(heading.indexOf(comma)+1)}
          textColor="#d31c4f"
          spanTextColor="#d31c4f"
          thirdTextColor="#d31c4f"
          textSize="48px"
          smTextSize="36px"
          leading="60px"
        />
      ) : (
        <CustomHeading
          text={heading}
          textColor="#d31c4f"
          textSize="48px"
          smTextSize="36px"
          leading="60px"
        />
      )}

      {subHeading && (
        <div className=" text-base text-justify sm:text-[18px] lg:text-2xl text-[#383838] font-semibold font-Lato capitalize leading-6 lg:leading-[38.40px]">
          {subHeading}
        </div>
      )}
      <CustomContent
        text={content}
        leading="30px"
        textSize="20px"
        textColor="#383838"
      />
      <CustomGalleryModal images={images} paddingX={"0%"} paddingY={"10px"} />
    </div>
  );
};

export default CustomParagraphComponent;
